import { render } from "./ModelView.vue?vue&type=template&id=cab1020e&scoped=true"
import script from "./ModelView.vue?vue&type=script&lang=js"
export * from "./ModelView.vue?vue&type=script&lang=js"

import "./ModelView.vue?vue&type=style&index=0&id=cab1020e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cab1020e"]])

export default __exports__